// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3YR7F","notes":"Notes_notes__2rSeI","note":"Notes_note__2ADTU","markdown":"Notes_markdown__2ODmt"};